#import "./GenericEntryCard.graphql"
fragment RelatedItems on relatedItemsBlock_Entry {
    title: blockTitle
    caption
    entries {
        ... GenericEntryCard
    }
    backgroundColor
    customBackgroundColor
}
